import { QueryObserverOptions, useQuery } from 'react-query';

import FunctionKey from 'constants/functionKey';
import { useDlVaultContract } from 'clients/contracts/hooks';
import getNetworkRewardsSummary, {
  GetNetworkRewardsSummaryInput,
  GetNetworkRewardsSummaryOutput,
} from '.';

type TrimmedGetNetworkRewardsSummaryInput = Omit<GetNetworkRewardsSummaryInput, 'dlVaultContract'>;

export type UseGetNetworkRewardsSummaryQueryKey = [
  FunctionKey.GET_NETWORK_REWARDS_SUMMARY,
  TrimmedGetNetworkRewardsSummaryInput,
];

type Options = QueryObserverOptions<
  GetNetworkRewardsSummaryOutput,
  Error,
  GetNetworkRewardsSummaryOutput,
  GetNetworkRewardsSummaryOutput,
  UseGetNetworkRewardsSummaryQueryKey
>;

const useGetNetworkRewardsSummary = (input: TrimmedGetNetworkRewardsSummaryInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_NETWORK_REWARDS_SUMMARY, input],
    () => getNetworkRewardsSummary({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetNetworkRewardsSummary; 